import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';

import { SkeletonLoaderService } from 'app/shared/services/skeleton-loader.service';

import { SvgIconComponent } from '../../../shared/components/svg-icon/svg-icon.component';
import { SkeletonLoaderComponent } from '../../../shared/components/skeleton-loader/skeleton-loader.component';

import { IDiscoverItem } from '../../../interfaces/discover.interfaces';
import { ISvgConfig } from '../../../shared/interfaces/svg.interfaces';
import { IMediaLoadingState } from 'app/shared/interfaces/media.interfaces';

import { ESvgTypes } from '../../../shared/enums/svg.enums';
import { EImageUsage } from '../../../shared/enums/image-usage.enums';

import { slideInOut } from '../../../shared/animations/slideInOut.animations';
import { fadeAnimation, fadeAnimationSequence } from '../../../shared/animations/fade.animations';

@Component({
  selector: 'stxt-creator-card',
  standalone: true,
  imports: [CommonModule, NgOptimizedImage, SvgIconComponent, SkeletonLoaderComponent],
  templateUrl: './creator-card.component.html',
  styleUrl: './creator-card.component.scss',
  animations: [slideInOut, fadeAnimation, fadeAnimationSequence]
})
export class CreatorCardComponent implements OnInit, OnChanges {
  @Input() creatorItem: IDiscoverItem;
  @Input() selectedCreator: IDiscoverItem;

  public verifySvg: ISvgConfig = { fill: ESvgTypes.None, name: 'verified' };
  public primaryImageState: IMediaLoadingState = {
    isLoaded: false,
    isRendered: false
  };

  protected readonly EImageUsage = EImageUsage;

  constructor(private readonly skeletonLoaderService: SkeletonLoaderService) {}

  ngOnInit(): void {
    this.initializeImageLoading();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['creatorItem'] && this.creatorItem) {
      this.initializeImageLoading();
    }
  }

  initializeImageLoading(): void {
    this.resetImageState();
  }

  resetImageState(): void {
    this.primaryImageState = {
      isLoaded: false,
      isRendered: false
    };
  }

  onPrimaryImageLoad(event: Event): void {
    this.primaryImageState.isLoaded = true;
    this.skeletonLoaderService
      .handleImageStateChange(event, {
        isLoaded: this.primaryImageState.isLoaded,
        isRendered: this.primaryImageState.isRendered
      })
      .then(() => {
        this.primaryImageState.isRendered = true;
      });
  }

  onPrimaryImageError(): void {
    this.primaryImageState = {
      isLoaded: true,
      isRendered: true
    };
  }
}
